<template>
  <div>
    <div class="row">
      <div id="Aracena" class="embalse col col-md-4">
        <div class="tituloWrapper">
          <h3 class="titulo">ARACENA</h3>
          <hr />
        </div>
        <div class="vaso">
          <div
            id="agua"
            class="agua"
            :style="{ height: datosEmbalse.Aracena.porcentaje + '%' }"
          ></div>
          <div id="vaso" class="vasoC"></div>
        </div>
        <div class="contenidoWraper">
          <div class="volumen">
            <p class="porcentajeNumero" id="volumenAracena">
              {{ datosEmbalse.Aracena.porcentaje
              }}<span class="porcentajeSimbolo align-text-top">%</span>
            </p>
            <br /><br />
          </div>
        </div>
        <div class="capacidad">
          <p>
            Capacidad:
            <span class="datos">{{ capacidades.Aracena }} hm<sup>3</sup></span>
          </p>
          <p>
            Volumen Embalsado:
            <span class="datos"
              >{{ datosEmbalse.Aracena.volumen }} hm<sup>3</sup></span
            >
          </p>
        </div>
      </div>
      <div id="Zufre" class="embalse col col-md-4">
        <div class="tituloWrapper">
          <h3 class="titulo">ZUFRE</h3>
          <hr />
        </div>
        <div class="vaso">
          <div
            id="agua"
            class="agua"
            :style="{ height: datosEmbalse.Zufre.porcentaje + '%' }"
          ></div>
          <div id="vaso" class="vasoC"></div>
        </div>
        <div class="contenidoWraper">
          <div class="volumen">
            <p class="porcentajeNumero" id="volumenZufre">
              {{ datosEmbalse.Zufre.porcentaje
              }}<span class="porcentajeSimbolo align-text-top">%</span>
            </p>
            <br /><br />
          </div>
        </div>
        <div class="capacidad">
          <p>
            Capacidad:
            <span class="datos">{{ capacidades.Zufre }} hm<sup>3</sup></span>
          </p>
          <p>
            Volumen Embalsado:
            <span class="datos"
              >{{ datosEmbalse.Zufre.volumen }} hm<sup>3</sup></span
            >
          </p>
        </div>
      </div>
      <div id="Minilla" class="embalse col col-md-4">
        <div class="tituloWrapper">
          <h3 class="titulo">LA MINILLA</h3>
          <hr />
        </div>
        <div class="vaso">
          <div
            id="agua"
            class="agua"
            :style="{ height: datosEmbalse['La Minilla'].porcentaje + '%' }"
          ></div>
          <div id="vaso" class="vasoC"></div>
        </div>
        <div class="contenidoWraper">
          <div class="volumen">
            <p class="porcentajeNumero" id="volumenMinilla">
              {{ datosEmbalse["La Minilla"].porcentaje
              }}<span class="porcentajeSimbolo align-text-top">%</span>
            </p>
            <br /><br />
          </div>
        </div>
        <div class="capacidad">
          <p>
            Capacidad:
            <span class="datos"
              >{{ capacidades["La Minilla"] }} hm<sup>3</sup></span
            >
          </p>
          <p>
            Volumen Embalsado:
            <span class="datos"
              >{{ datosEmbalse["La Minilla"].volumen }} hm<sup>3</sup></span
            >
          </p>
        </div>
      </div>
      <div id="Gergal" class="embalse col col-md-4">
        <div class="tituloWrapper">
          <h3 class="titulo">EL GERGAL</h3>
          <hr />
        </div>
        <div class="vaso">
          <div
            id="agua"
            class="agua"
            :style="{ height: datosEmbalse['El Gergal'].porcentaje + '%' }"
          ></div>
          <div id="vaso" class="vasoC"></div>
        </div>
        <div class="contenidoWraper">
          <div class="volumen">
            <p class="porcentajeNumero" id="volumenGergal">
              {{ datosEmbalse["El Gergal"].porcentaje
              }}<span class="porcentajeSimbolo align-text-top">%</span>
            </p>
            <br /><br />
          </div>
        </div>
        <div class="capacidad">
          <p>
            Capacidad:
            <span class="datos"
              >{{ capacidades["El Gergal"] }} hm<sup>3</sup></span
            >
          </p>
          <p>
            Volumen Embalsado:
            <span class="datos"
              >{{ datosEmbalse["El Gergal"].volumen }} hm<sup>3</sup></span
            >
          </p>
        </div>
      </div>
      <div id="Melonares" class="embalse col col-md-4">
        <div class="tituloWrapper">
          <h3 class="titulo">LOS MELONARES</h3>
          <hr />
        </div>
        <div class="vaso">
          <div
            id="agua"
            class="agua"
            :style="{
              height: datosEmbalse['Los Melonares'].porcentaje + '%',
            }"
          ></div>
          <div id="vaso" class="vasoC"></div>
        </div>
        <div class="contenidoWraper">
          <div class="volumen">
            <p class="porcentajeNumero" id="volumenMelonares">
              {{ datosEmbalse["Los Melonares"].porcentaje
              }}<span class="porcentajeSimbolo align-text-top">%</span>
            </p>
            <br /><br />
          </div>
        </div>
        <div class="capacidad">
          <p>
            Capacidad:
            <span class="datos"
              >{{ capacidades["Los Melonares"] }} hm<sup>3</sup></span
            >
          </p>
          <p>
            Volumen Embalsado:
            <span class="datos"
              >{{ datosEmbalse["Los Melonares"].volumen }} hm<sup>3</sup></span
            >
          </p>
        </div>
      </div>
      <div id="Cala" class="embalse col col-md-4">
        <div class="tituloWrapper">
          <h3 class="titulo">CALA</h3>
          <hr />
        </div>
        <div class="vaso">
          <div
            id="agua"
            class="agua"
            :style="{ height: datosEmbalse.Cala.porcentaje + '%' }"
          ></div>
          <div id="vaso" class="vasoC"></div>
        </div>
        <div class="contenidoWraper">
          <div class="volumen">
            <p class="porcentajeNumero" id="volumenCala">
              {{ datosEmbalse.Cala.porcentaje
              }}<span class="porcentajeSimbolo align-text-top">%</span>
            </p>
            <br /><br />
          </div>
        </div>
        <div class="capacidad">
          <p>
            Capacidad:
            <span class="datos">{{ capacidades.Cala }} hm<sup>3</sup></span>
          </p>
          <p>
            Volumen Embalsado:
            <span class="datos"
              >{{ datosEmbalse.Cala.volumen }} hm<sup>3</sup></span
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  props: ["volumenesFinales"],
  data() {
    return {
    capacidades: {
        Aracena:  128.650,
        Zufre: 175.270,
        "La Minilla": 57.800,
        Cala: 58.800,
        "El Gergal": 35.040,
        "Los Melonares":  185.600 
      },
      datosEmbalse: {
        Aracena: {
          volumen: null,
          porcentaje: null,
        },
        "El Gergal": {
          volumen: null,
          porcentaje: null,
        },
        "Los Melonares": {
          volumen: null,
          porcentaje: null,
        },
        "La Minilla": {
          volumen: null,
          porcentaje: null,
        },
        Zufre: {
          volumen: null,
          porcentaje: null,
        },
        Cala: {
          volumen: null,
          porcentaje: null,
        },
      },
    };
  },
  components: {},
  computed: {
    ...mapState("planner", ["v_capacity"]),
  },
  watch: {
    volumenesFinales: function (newVal, oldVal) {
      this.getDatosEmbalse();
    },
  },
  methods: {
    //Este método rellena los datos de cada embalse menos la capacidad, que está en vuex.
    getDatosEmbalse() {
  //console.log("volumenesFinales:", this.volumenesFinales);

  for (let i = 0; i < this.volumenesFinales.length; i++) {
    // Convertir volumen a tipo numérico (flotante)
    let volumen = parseFloat(this.volumenesFinales[i].extraido.value);
    // Obtener la capacidad correspondiente del embalse
    let capacidad = this.capacidades[this.volumenesFinales[i].label];
    
    // console.log(`Volumen para ${this.volumenesFinales[i].label}:`, volumen);
    // console.log(`Capacidad para ${this.volumenesFinales[i].label}:`, capacidad);

    // Verificar si tanto volumen como capacidad son números válidos
    if (isNaN(volumen) || isNaN(capacidad)) {
      //console.log(`Datos inválidos para ${this.volumenesFinales[i].label}: volumen o capacidad`);
      continue; // Si los datos no son válidos, saltamos este embalse
    }

    // Calcular el porcentaje de volumen respecto a la capacidad
    let porcentaje = this.percentajeCalculator(capacidad, volumen);
    //console.log(`Porcentaje para ${this.volumenesFinales[i].label}:`, porcentaje);

    // Asignar el volumen y el porcentaje a los datos del embalse
    this.datosEmbalse[this.volumenesFinales[i].label].volumen = this.roundTwoDecimals(volumen);
    this.datosEmbalse[this.volumenesFinales[i].label].porcentaje = this.roundTwoDecimals(porcentaje);
  }
}


,
    roundTwoDecimals(num) {
      return Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100;
    },
    percentajeCalculator(capacidad, volumen) {
      return (volumen / capacidad) * 100;
    },
  },
  async mounted() {},
};
</script>

<style scoped>
/* Clase para que las anotaciones tengan el mismo estilo que los Select*/
.form-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #333333;
}

.vaso {
  width: 100px;
  height: 120px;
  position: relative;
  float: left;
}
.agua {
  max-height: 90%;
  width: 99px;
  background: #9ad8f6;
  margin-left: 1px;
  position: absolute;
  bottom: 8px;
  -webkit-border-radius: 0px 0px 5px 5px;
  -moz-border-radius: 0px 0px 5px 5px;
  border-radius: 0px 0px 5px 5px;
}
.vaso .vasoC {
  width: 100px;
  height: 120px;
  background: url(~@/assets/img/vaso.png) no-repeat;
  position: relative;
}
.embalse {
  display: inline-block;
  margin-bottom: 20px;
  margin-top: 20px;
  min-width: 200px;
}
.tituloWrapper {
  padding-bottom: 11px;
  margin-top: -2px;
}
.contenidoWraper {
  float: left;
  margin-left: 10px;
}
hr {
  max-width: 90%;
}
.titulo {
  font-size: 18px;
  color: rgb(51, 51, 51);
  font-family: Helvetica, Arial, sans-serif !important;
  font-weight: bold;
}
.volumen p {
  font-family: Helvetica, Arial, sans-serif !important;
}
.porcentajeNumero {
  font-size: 50px;
  font-weight: bold;
  color: rgb(34, 147, 197);
}
.porcentajeSimbolo {
  font-size: 62%;
  color: rgb(172, 172, 172);
  font-weight: normal;
}
.capacidad {
  float: left;
}
.capacidad p {
  font-size: 15px;
  color: rgb(51, 51, 51);
  font-family: Helvetica, Arial, sans-serif !important;
  font-weight: bold;
  margin-top: 10px;
  line-height: 0.5;
}

.capacidad .datos {
  color: rgb(34, 147, 197);
}
</style>